import React, { useEffect, useState, useRef } from 'react'; //import React Component
import { cloudStore } from '../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

export function AllOwnOrder() {
    let userID = localStorage.getItem("currentLoginUserID");

    const [ownOrderCollection, setownOrderCollection] = useState([])
    useEffect(() => {
        if (userID !== null) {
            getDocs(query(collection(cloudStore, "orderInfo"), where("userID", "==", userID)))
                .then((querySnapshot) => {
                    const data = querySnapshot.docs.map((doc) => doc.data());
                    setownOrderCollection(data)
                })
        }
    }, []);

    const [ifshow_more, setifshow_more] = useState(false)
    const [showwhich, setshowwhich] = useState(false)
    const show_more = (e) => {
        let value = e.target.dataset.values
        setshowwhich(value)
        if (ifshow_more) {
            setifshow_more(false)
        } else {
            setifshow_more(true)
        }
    }

    let eachCollection = null
    if (ownOrderCollection.length > 0) {
        let eachItem = ownOrderCollection[0].User_Order
        eachItem.sort((a, b) => a[Object.keys(a)]["time"] - b[Object.keys(b)]["time"])
            .sort((a, b) => {
                const aStatus = a[Object.keys(a)]["status"];
                const bStatus = b[Object.keys(b)]["status"];

                if (aStatus === "订单已取消" && bStatus !== "订单已取消") {
                    return -1; // put a before b in the sorted array
                } else if (aStatus !== "订单已取消" && bStatus === "订单已取消") {
                    return 1; // put b before a in the sorted array
                } else {
                    return 0; // don't change the order of a and b in the sorted array
                }
            })
            .sort((a, b) => {
                const aStatus = a[Object.keys(a)]["status"];
                const bStatus = b[Object.keys(b)]["status"];

                if (aStatus === "订单已确认" && bStatus !== "订单已确认") {
                    return -1; // put a before b in the sorted array
                } else if (aStatus !== "订单已确认" && bStatus === "订单已确认") {
                    return 1; // put b before a in the sorted array
                } else {
                    return 0; // don't change the order of a and b in the sorted array
                }
            })
            .sort((a, b) => {
                const aStatus = a[Object.keys(a)]["status"];
                const bStatus = b[Object.keys(b)]["status"];

                if (aStatus === "等待确认" && bStatus !== "等待确认") {
                    return -1; // put a before b in the sorted array
                } else if (aStatus !== "等待确认" && bStatus === "等待确认") {
                    return 1; // put b before a in the sorted array
                } else {
                    return 0; // don't change the order of a and b in the sorted array
                }
            })
        eachCollection = eachItem.map((content, index) => {
            let eachItem = Object.values(content)[0]
            let orderItem = eachItem.orderItem
            const keys = Object.keys(orderItem[0]);
            const itemName = keys.find((key) => key !== 'price');
            let coupon = eachItem.coupon
            let delivery = eachItem.delivery
            let totalPrice = parseFloat(eachItem.totalPrice).toFixed(2)
            let status = eachItem.status
            let reason = eachItem.reason
            let orderID = eachItem.orderID
            if (coupon > 0) {
                totalPrice -= coupon
            }
            if (delivery === "商家配送(1$)") {
                totalPrice += 1
            }

            const item = orderItem.map((item) => {
                const keys = Object.keys(item);
                const itemName = keys.find((key) => key !== 'price');
                // console.log(item.itemName)
                return (
                    <p style={{ textAlign: "left" }} key={itemName}>{itemName} * {item[itemName]}</p>
                )
            })

            return (
                <div className="each" key={eachItem.time} style={{ padding: "10px", width: "240px" }}>
                    <div className='eachshoworder' >
                        <h3 style={{ textAlign: "left" }}>状态: {status}</h3>
                        {status === "订单已取消" && reason.length > 0 ?
                            <>
                                <p style={{ textAlign: "left" }}>订单取消原因: {reason}</p>
                            </> : null
                        }
                        {ifshow_more === true && index === parseInt(showwhich) ?
                            <>
                                <p style={{ textAlign: "left" }}>商品信息:</p>
                                {item}
                            </> : null
                        }
                        {ifshow_more === true && index !== parseInt(showwhich) ?
                            <>
                                <p style={{ textAlign: "left" }}>商品信息：{itemName} * {orderItem[0][itemName]}</p>
                            </> : null
                        }
                        {ifshow_more === false ?
                            <>
                                <p style={{ textAlign: "left" }}>商品信息：{itemName} * {orderItem[0][itemName]}</p>
                            </> : null
                        }
                        <span
                            className="material-symbols-outlined show_more"
                            onClick={(e) => show_more(e)}
                            data-values={index}
                            style={{ textAlign: "center" }}>expand_more
                        </span>
                        <p style={{ textAlign: "left" }}>总价格：{totalPrice}$</p>
                        <p style={{ textAlign: "left" }}>订单号：{orderID}</p>
                    </div>
                </div >
            )

        })
    }

    return (
        <div className='collection_content'>
            <div className='h2bg'>
                <h2>您的订单信息</h2>
            </div>
            <div className="store">
                {eachCollection}
            </div>
        </div>
    );
}